import { formatNumber } from '../../../../utils';

import { DEFAULT_LANG } from '~/constants';

interface QuickAmountButtonProps {
  amount: number;
  isSelected: boolean;
  bonus?: number; // 奖励百分比
  isDisabled?: boolean;
  onClick?: () => void;
  class?: string;
}

/**
 * 快捷金额选择按钮
 * 支持显示金额、奖励加成和选中状态
 */
function QuickAmountButton(props: QuickAmountButtonProps) {
  return (
    <button
      type="button"
      disabled={props.isDisabled}
      onClick={props.onClick}
      class={cx(
        'w-full rounded-lg  px-3 border transition-all duration-200 h-11 flex flex-col items-center text-sm justify-center ',
        'text-center font-semibold',
        'hover:bg-layer6 disabled:opacity-60 disabled:cursor-not-allowed',
        'relative bg-layer4-card',
        // 选中状态
        props.isSelected ? 'border-brand text-brand-default' : 'border-main1  text-neutral-main1',
        // 禁用状态
        props.isDisabled && 'diagonal-stripes',
        props.class
      )}
    >
      <div class="font-semibold h-4">{formatNumber(props.amount, DEFAULT_LANG, 2, 2)}</div>
      {props.bonus && (
        <div
          class=" text-function-autoreverse font-semibold h-3 text-[12px] leading-none p-0.5 mt-[6px] pb-3 rounded-[4px]"
          style={{
            background: 'var(--text-function-highlight)',
          }}
        >
          +{props.bonus}%
        </div>
      )}
      {props.isSelected && <IconFinish class="absolute -top-1 -right-1 z-10 w-[10px] h-[10px]" />}
    </button>
  );
}

export default QuickAmountButton;
